import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=a9ac5274"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=a9ac5274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports